<div class="popup-container">
  <div class="popup-heading pl-5 pt-5">
    Details
  </div>
  <hr class="separator">
  @if(data.tasks.length == 0) {
    <div class="text-center text-gray-500">
      Job name: {{data.name}}<br />
      Provider BU: {{data.provider_bu.name}}<br />
      Message: {{data.description}}
    </div>
  }@else{
    @for(task of data.tasks; track task; let index = $index) {
      <div class="mt-3">
        <div class="menu pl-8 pt-2" (click)="toggleDropdown(index)">
          <i
            class="fa fa-chevron-up"
            [ngClass]="{ rotate: toggleStates[index] }"
          ></i>
          <span class="p-2 font-bold" [ngClass]="{'error-text-decoration': task.status_id == 1}">{{task.filename}} - {{task.title}}</span>
        </div>
        <div *ngIf="toggleStates[index]" class="reqRes-details">
          <div class="px-10 pt-2">
            <table class="striped-table">
              <thead>
                <tr class="bg-secondary">
                  <th width="15%">Step</th>
                  <th width="70%">Message</th>
                  <th width="5%">Status</th>
                  <th width="5%">Start Time</th>
                  <th width="5%">End Time</th>
                </tr>
              </thead>
              <tbody>
                @for (step of task.steps; track step) {
                  <tr [ngClass]="{ 'error-background': step.status_id == 1 }">
                    <td class="first">{{step.step_name}}</td>
                    <td class="second">{{step.message}}</td>
                    <td class="first">{{step.status.name}}</td>
                    <td class="second">
                      {{step.start_time | date: 'MM/dd/yyyy HH:mm'}}<br />
                    </td>
                    <td class="first">
                      {{step.end_time | date: 'MM/dd/yyyy HH:mm'}}<br />
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    }
  }
  <hr class="separator">
  <div style="height: 50px;">
    <button class="close" (click)="closePopup()">Close</button>
  </div>
</div>